(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gf-brand-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-brand-marquee')) {
    customElements.define('gf-brand-marquee', class extends HTMLElement {
      connectedCallback() {
        if(this.initialized)return;
        this.initialized=true;
        this.items=Array.from(this.querySelectorAll('[data-brand-item]'));
        this.start=0;this.columns=0;this.inView=false;this.paused=false;this.hovering=false;this.focused=false;
        this.motion=matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController=new AbortController();
        const signal=this.abortController.signal;
        this.addEventListener('click',event=>{
          const direction=event.target.closest('[data-brand-direction]');
          if(direction){this.shift(Number(direction.dataset.brandDirection));}
          const toggle=event.target.closest('[data-brand-toggle]');
          if(toggle){this.paused=!this.paused;this.updateToggle();this.schedule();}
        },{signal});
        this.addEventListener('focusin',event=>{this.focused=!!event.target.closest('a');this.schedule();},{signal});
        this.addEventListener('focusout',event=>{this.focused=!!(event.relatedTarget&&this.contains(event.relatedTarget)&&event.relatedTarget.closest('a'));this.schedule();},{signal});
        document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
        this.motion.addEventListener('change',()=>{this.updateToggle();this.schedule();},{signal});
        this.addEventListener('shopify:block:select',event=>{
          const index=this.items.findIndex(item=>item===event.target||item.contains(event.target));
          if(index>=0){this.paused=true;this.cancelShift();this.showWindow(index);this.updateToggle();this.schedule();}
        },{signal});
        this.resizeObserver=new ResizeObserver(entries=>{
          const width=entries[0].contentRect.width;
          const columns=Math.max(1,Math.min(this.items.length,Math.floor(width/(width<750?265:350))));
          if(columns===this.columns)return;
          this.cancelShift();
          this.columns=columns;
          this.style.setProperty('--gf-brand-columns',String(columns));
          this.showWindow(this.start);this.schedule();
        });
        this.resizeObserver.observe(this);
        this.visibilityObserver=new IntersectionObserver(entries=>{
          this.inView=entries[0].isIntersecting;this.schedule();
        },{threshold:.1});
        this.visibilityObserver.observe(this);
        this.updateToggle();
      }
      mount(item){
        const template=item.querySelector('template[data-brand-content]');
        if(template){item.append(template.content);template.remove();}
      }
      unmount(item){
        if(item.querySelector('template[data-brand-content]'))return;
        const template=document.createElement('template');template.setAttribute('data-brand-content','');
        while(item.firstChild)template.content.append(item.firstChild);
        item.append(template);
      }
      showWindow(start){
        if(!this.items.length||!this.columns)return;
        const count=this.items.length;
        this.start=(start+count)%count;
        const visible=Array.from({length:this.columns},(_,index)=>(this.start+index)%count);
        this.items.forEach((item,index)=>{
          const show=visible.includes(index);
          if(show)this.mount(item);else this.unmount(item);
          item.hidden=!show;item.removeAttribute('aria-hidden');item.inert=false;
        });
        const group=this.querySelector('.gf-brands__group');
        visible.forEach(index=>group.append(this.items[index]));
        this.querySelector('.gf-brands__controls').hidden=count<=this.columns;
        this.querySelectorAll('[data-brand-direction]').forEach(button=>button.disabled=count<=this.columns);
        this.querySelector('[data-brand-status]').textContent=(this.start+1)+' / '+count;
      }
      cancelShift(){
        clearTimeout(this.shiftTimer);
        cancelAnimationFrame(this.shiftFrame);
        if(this.group){this.group.style.transition='none';this.group.style.transform='translateX(0)';}
        this.shifting=false;
      }
      shift(direction){
        if(this.shifting||this.items.length<=this.columns)return;
        clearTimeout(this.timer);
        const count=this.items.length;
        const target=(this.start+direction+count)%count;
        if(this.motion.matches){this.showWindow(target);this.schedule();return;}
        this.shifting=true;
        this.items.filter(item=>item.hidden).forEach(item=>this.unmount(item));
        this.group=this.querySelector('.gf-brands__group');
        const extra=this.items[(direction>0?this.start+this.columns:target)%count];
        this.mount(extra);extra.hidden=false;extra.inert=true;extra.setAttribute('aria-hidden','true');
        extra.querySelectorAll('img').forEach(image=>image.loading='eager');
        this.group.style.transition='none';
        if(direction>0){this.group.append(extra);this.group.style.transform='translateX(0)';}
        else{this.group.prepend(extra);this.group.style.transform='translateX(-'+(100/this.columns)+'%)';}
        this.shiftFrame=requestAnimationFrame(()=>{
          this.shiftFrame=requestAnimationFrame(()=>{
            if(!this.shifting)return;
            this.group.style.transition='transform 650ms ease-in-out';
            this.group.style.transform=direction>0?'translateX(-'+(100/this.columns)+'%)':'translateX(0)';
            this.shiftTimer=setTimeout(()=>{this.cancelShift();this.showWindow(target);this.schedule();},680);
          });
        });
      }
      updateToggle(){
        const button=this.querySelector('[data-brand-toggle]');
        const paused=this.paused||this.motion.matches;
        button.setAttribute('aria-pressed',String(paused));
        button.setAttribute('aria-label',paused?button.dataset.resumeLabel:button.dataset.pauseLabel);
        button.textContent=paused?'▶':'Ⅱ';button.disabled=this.motion.matches;
      }
      schedule(){
        clearTimeout(this.timer);
        if(this.shifting)return;
        const running=this.inView&&!document.hidden&&!this.paused&&!this.focused&&!this.motion.matches&&this.columns>0&&this.items.length>this.columns;
        this.setAttribute('data-brand-running',String(running));
        this.querySelector('[data-brand-status]').setAttribute('aria-live',running?'off':'polite');
        if(!running)return;
        const next=this.items[(this.start+this.columns)%this.items.length];
        this.mount(next);
        next.querySelectorAll('img').forEach(image=>image.loading='eager');
        this.timer=setTimeout(()=>this.shift(1),5000);
      }
      disconnectedCallback(){this.cancelShift();clearTimeout(this.timer);this.abortController?.abort();this.resizeObserver?.disconnect();this.visibilityObserver?.disconnect();this.initialized=false;}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-hair-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-hair-slideshow')) {
    customElements.define('gf-hair-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-hair-slide]'));
        this.track = this.querySelector('.gf-hair__track');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-hair-direction')) this.go(this.current + Number(button.dataset.hairDirection));
          if (button.hasAttribute('data-hair-products')) {
            const list = button.closest('.gf-hair__products').querySelector('.gf-hair__product-list');
            const first = list.querySelector('.gf-hair__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.hairProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});

        this.slides.forEach(slide => this.bindSlide(slide));

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});


        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-hair__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.go(0, false);
      }
      hydrateSlide(index, bind = true) {
        const slide = this.slides[index];
        const deferred = slide?.querySelector('template[data-gf-deferred-slide]');
        if (!deferred) return;
        deferred.replaceWith(deferred.content.cloneNode(true));
        if (bind) this.bindSlide(slide);
      }
      bindSlide(slide) {
        const signal = this.abortController.signal;
        slide.querySelectorAll('.gf-hair__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });
        slide.querySelectorAll('.gf-hair__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};}, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;}, {passive:true, signal});
        });
      }
      go(index, loadImage = true) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.hydrateSlide(this.current);
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-hair-status]');
        if (status) {
          status.setAttribute('aria-live','polite');
          status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        }
        const hero=this.slides[this.current].querySelector('.gf-hair__hero-image, .gf-hair__hero-product');
        if (hero && loadImage) hero.loading='eager';
        requestAnimationFrame(() => this.slides[this.current]?.querySelectorAll('.gf-hair__product-list').forEach(list => this.updateRail(list)));
      }
      updateRail(list) {
        this.pendingRails ||= new Set();
        this.pendingRails.add(list);
        if (this.railFrame) return;
        this.railFrame = requestAnimationFrame(() => {
          this.railFrame = 0;
          const updates = [];
          for (const rail of this.pendingRails) {
            if (!rail.isConnected || rail.closest('[aria-hidden="true"]')) continue;
            const controls = rail.closest('.gf-hair__products');
            const prev = controls?.querySelector('[data-hair-products="-1"]');
            const next = controls?.querySelector('[data-hair-products="1"]');
            const left = rail.scrollLeft;
            const width = rail.clientWidth;
            const total = rail.scrollWidth;
            updates.push({prev, next, atStart: left < 2, atEnd: left + width >= total - 3});
          }
          this.pendingRails.clear();
          for (const {prev, next, atStart, atEnd} of updates) {
            if (prev && prev.disabled !== atStart) prev.disabled = atStart;
            if (next && next.disabled !== atEnd) next.disabled = atEnd;
          }
        });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.railFrame);
        this.railFrame = 0;
        this.pendingRails?.clear();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-mamy-baby-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-mamy-slideshow')) {
    customElements.define('gf-mamy-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-mamy-slide]'));
        this.track = this.querySelector('.gf-mamy__track');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-mamy-direction')) this.go(this.current + Number(button.dataset.mamyDirection));
          if (button.hasAttribute('data-mamy-products')) {
            const list = button.closest('.gf-mamy__products').querySelector('.gf-mamy__product-list');
            const first = list.querySelector('.gf-mamy__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.mamyProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});

        this.slides.forEach(slide => this.bindSlide(slide));

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});


        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-mamy__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.go(0, false);
      }
      hydrateSlide(index, bind = true) {
        const slide = this.slides[index];
        const deferred = slide?.querySelector('template[data-gf-deferred-slide]');
        if (!deferred) return;
        deferred.replaceWith(deferred.content.cloneNode(true));
        if (bind) this.bindSlide(slide);
      }
      bindSlide(slide) {
        const signal = this.abortController.signal;
        slide.querySelectorAll('.gf-mamy__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });
        slide.querySelectorAll('.gf-mamy__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};}, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;}, {passive:true, signal});
        });
      }
      go(index, loadImage = true) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.hydrateSlide(this.current);
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-mamy-status]');
        if (status) {
          status.setAttribute('aria-live','polite');
          status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        }
        const hero=this.slides[this.current].querySelector('.gf-mamy__hero-image, .gf-mamy__hero-product');
        if (hero && loadImage) hero.loading='eager';
        requestAnimationFrame(() => this.slides[this.current]?.querySelectorAll('.gf-mamy__product-list').forEach(list => this.updateRail(list)));
      }
      updateRail(list) {
        this.pendingRails ||= new Set();
        this.pendingRails.add(list);
        if (this.railFrame) return;
        this.railFrame = requestAnimationFrame(() => {
          this.railFrame = 0;
          const updates = [];
          for (const rail of this.pendingRails) {
            if (!rail.isConnected || rail.closest('[aria-hidden="true"]')) continue;
            const controls = rail.closest('.gf-mamy__products');
            const prev = controls?.querySelector('[data-mamy-products="-1"]');
            const next = controls?.querySelector('[data-mamy-products="1"]');
            const left = rail.scrollLeft;
            const width = rail.clientWidth;
            const total = rail.scrollWidth;
            updates.push({prev, next, atStart: left < 2, atEnd: left + width >= total - 3});
          }
          this.pendingRails.clear();
          for (const {prev, next, atStart, atEnd} of updates) {
            if (prev && prev.disabled !== atStart) prev.disabled = atStart;
            if (next && next.disabled !== atEnd) next.disabled = atEnd;
          }
        });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.railFrame);
        this.railFrame = 0;
        this.pendingRails?.clear();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-men-body-oral-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-mbo-slideshow')) {
    customElements.define('gf-mbo-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-mbo-slide]'));
        this.track = this.querySelector('.gf-mbo__track');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-mbo-direction')) this.go(this.current + Number(button.dataset.mboDirection));
          if (button.hasAttribute('data-mbo-products')) {
            const list = button.closest('.gf-mbo__products').querySelector('.gf-mbo__product-list');
            const first = list.querySelector('.gf-mbo__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.mboProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});

        this.slides.forEach(slide => this.bindSlide(slide));

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});


        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-mbo__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.go(0, false);
      }
      hydrateSlide(index, bind = true) {
        const slide = this.slides[index];
        const deferred = slide?.querySelector('template[data-gf-deferred-slide]');
        if (!deferred) return;
        deferred.replaceWith(deferred.content.cloneNode(true));
        if (bind) this.bindSlide(slide);
      }
      bindSlide(slide) {
        const signal = this.abortController.signal;
        slide.querySelectorAll('.gf-mbo__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });
        slide.querySelectorAll('.gf-mbo__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};}, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;}, {passive:true, signal});
        });
      }
      go(index, loadImage = true) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.hydrateSlide(this.current);
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-mbo-status]');
        if (status) {
          status.setAttribute('aria-live','polite');
          status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        }
        const hero=this.slides[this.current].querySelector('.gf-mbo__hero-image, .gf-mbo__hero-product');
        if (hero && loadImage) hero.loading='eager';
        requestAnimationFrame(() => this.slides[this.current]?.querySelectorAll('.gf-mbo__product-list').forEach(list => this.updateRail(list)));
      }
      updateRail(list) {
        this.pendingRails ||= new Set();
        this.pendingRails.add(list);
        if (this.railFrame) return;
        this.railFrame = requestAnimationFrame(() => {
          this.railFrame = 0;
          const updates = [];
          for (const rail of this.pendingRails) {
            if (!rail.isConnected || rail.closest('[aria-hidden="true"]')) continue;
            const controls = rail.closest('.gf-mbo__products');
            const prev = controls?.querySelector('[data-mbo-products="-1"]');
            const next = controls?.querySelector('[data-mbo-products="1"]');
            const left = rail.scrollLeft;
            const width = rail.clientWidth;
            const total = rail.scrollWidth;
            updates.push({prev, next, atStart: left < 2, atEnd: left + width >= total - 3});
          }
          this.pendingRails.clear();
          for (const {prev, next, atStart, atEnd} of updates) {
            if (prev && prev.disabled !== atStart) prev.disabled = atStart;
            if (next && next.disabled !== atEnd) next.disabled = atEnd;
          }
        });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.railFrame);
        this.railFrame = 0;
        this.pendingRails?.clear();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-skincare-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-care-slideshow')) {
    customElements.define('gf-care-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-care-slide]'));
        this.track = this.querySelector('.gf-care__track');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-care-direction')) this.go(this.current + Number(button.dataset.careDirection));
          if (button.hasAttribute('data-care-products')) {
            const list = button.closest('.gf-care__products').querySelector('.gf-care__product-list');
            const first = list.querySelector('.gf-care__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.careProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});

        this.slides.forEach(slide => this.bindSlide(slide));

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});


        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-care__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.go(0, false);
      }
      hydrateSlide(index, bind = true) {
        const slide = this.slides[index];
        const deferred = slide?.querySelector('template[data-gf-deferred-slide]');
        if (!deferred) return;
        deferred.replaceWith(deferred.content.cloneNode(true));
        if (bind) this.bindSlide(slide);
      }
      bindSlide(slide) {
        const signal = this.abortController.signal;
        slide.querySelectorAll('.gf-care__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });
        slide.querySelectorAll('.gf-care__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {
            touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};
          }, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;}, {passive:true, signal});
        });
      }
      go(index, loadImage = true) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.hydrateSlide(this.current);
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-care-status]');
        if (status) {
          status.setAttribute('aria-live','polite');
          status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        }
        const hero=this.slides[this.current].querySelector('.gf-care__hero-image, .gf-care__hero-product');
        if (hero && loadImage) hero.loading='eager';
        requestAnimationFrame(() => this.slides[this.current]?.querySelectorAll('.gf-care__product-list').forEach(list => this.updateRail(list)));
      }
      updateRail(list) {
        this.pendingRails ||= new Set();
        this.pendingRails.add(list);
        if (this.railFrame) return;
        this.railFrame = requestAnimationFrame(() => {
          this.railFrame = 0;
          const updates = [];
          for (const rail of this.pendingRails) {
            if (!rail.isConnected || rail.closest('[aria-hidden="true"]')) continue;
            const controls = rail.closest('.gf-care__products');
            const prev = controls?.querySelector('[data-care-products="-1"]');
            const next = controls?.querySelector('[data-care-products="1"]');
            const left = rail.scrollLeft;
            const width = rail.clientWidth;
            const total = rail.scrollWidth;
            updates.push({prev, next, atStart: left < 2, atEnd: left + width >= total - 3});
          }
          this.pendingRails.clear();
          for (const {prev, next, atStart, atEnd} of updates) {
            if (prev && prev.disabled !== atStart) prev.disabled = atStart;
            if (next && next.disabled !== atEnd) next.disabled = atEnd;
          }
        });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.railFrame);
        this.railFrame = 0;
        this.pendingRails?.clear();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-supplements-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-supp-slideshow')) {
    customElements.define('gf-supp-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-supp-slide]'));
        this.track = this.querySelector('.gf-supp__track');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-supp-direction')) this.go(this.current + Number(button.dataset.suppDirection));
          if (button.hasAttribute('data-supp-products')) {
            const list = button.closest('.gf-supp__products').querySelector('.gf-supp__product-list');
            const first = list.querySelector('.gf-supp__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.suppProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});

        this.slides.forEach(slide => this.bindSlide(slide));

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});


        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-supp__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.go(0, false);
      }
      hydrateSlide(index, bind = true) {
        const slide = this.slides[index];
        const deferred = slide?.querySelector('template[data-gf-deferred-slide]');
        if (!deferred) return;
        deferred.replaceWith(deferred.content.cloneNode(true));
        if (bind) this.bindSlide(slide);
      }
      bindSlide(slide) {
        const signal = this.abortController.signal;
        slide.querySelectorAll('.gf-supp__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });
        slide.querySelectorAll('.gf-supp__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};}, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;}, {passive:true, signal});
        });
      }
      go(index, loadImage = true) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.hydrateSlide(this.current);
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-supp-status]');
        if (status) {
          status.setAttribute('aria-live','polite');
          status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        }
        const hero=this.slides[this.current].querySelector('.gf-supp__hero-image, .gf-supp__hero-product');
        if (hero && loadImage) hero.loading='eager';
        requestAnimationFrame(() => this.slides[this.current]?.querySelectorAll('.gf-supp__product-list').forEach(list => this.updateRail(list)));
      }
      updateRail(list) {
        this.pendingRails ||= new Set();
        this.pendingRails.add(list);
        if (this.railFrame) return;
        this.railFrame = requestAnimationFrame(() => {
          this.railFrame = 0;
          const updates = [];
          for (const rail of this.pendingRails) {
            if (!rail.isConnected || rail.closest('[aria-hidden="true"]')) continue;
            const controls = rail.closest('.gf-supp__products');
            const prev = controls?.querySelector('[data-supp-products="-1"]');
            const next = controls?.querySelector('[data-supp-products="1"]');
            const left = rail.scrollLeft;
            const width = rail.clientWidth;
            const total = rail.scrollWidth;
            updates.push({prev, next, atStart: left < 2, atEnd: left + width >= total - 3});
          }
          this.pendingRails.clear();
          for (const {prev, next, atStart, atEnd} of updates) {
            if (prev && prev.disabled !== atStart) prev.disabled = atStart;
            if (next && next.disabled !== atEnd) next.disabled = atEnd;
          }
        });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.railFrame);
        this.railFrame = 0;
        this.pendingRails?.clear();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-three-slides-copy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-care-slideshow')) {
    customElements.define('gf-care-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-care-slide]'));
        this.track = this.querySelector('.gf-care__track');
        this.interval = Math.min(7000, Math.max(5000, Number(this.dataset.interval) || 6000));
        this.visible = false;
        this.hovered = this.matches(':hover');
        this.focused = this.contains(document.activeElement);
        this.editor = Boolean(window.Shopify?.designMode);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-care-direction')) this.go(this.current + Number(button.dataset.careDirection));
          if (button.hasAttribute('data-care-products')) {
            const list = button.closest('.gf-care__products').querySelector('.gf-care__product-list');
            const first = list.querySelector('.gf-care__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(list).gap);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.careProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});
        this.addEventListener('pointerenter', event => {if (event.pointerType === 'mouse') {this.hovered=true;this.schedule();}}, {signal});
        this.addEventListener('pointerleave', event => {if (event.pointerType === 'mouse') {this.hovered=false;this.schedule();}}, {signal});
        this.addEventListener('focusin', () => {this.focused=true;this.schedule();}, {signal});
        this.addEventListener('focusout', () => {queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();});}, {signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.motion.addEventListener('change', () => this.schedule(), {signal});
        this.querySelectorAll('.gf-care__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});
        this.querySelectorAll('.gf-care__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};this.touching=true;this.schedule();}, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;this.touching=false;this.schedule();
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;this.touching=false;this.schedule();}, {passive:true, signal});
        });
        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-care__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.intersectionObserver = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();},{threshold:0});
        this.intersectionObserver.observe(this);
        this.preloadNext();
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.hovered || this.focused || this.touching || !this.visible || document.hidden || this.motion.matches || this.editor) return;
        this.timer=setTimeout(()=>this.go(this.current+1, true),this.interval);
      }
      preloadNext() {
        if (!this.slides.length) return;
        const image=this.slides[(this.current+1)%this.slides.length].querySelector('.gf-care__hero-image');
        if (image) image.loading='eager';
      }
      go(index, automatic=false) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-care-status]');
        status.setAttribute('aria-live',automatic?'off':'polite');
        status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        this.slides[this.current].querySelectorAll('img[loading="lazy"]').forEach(img=>{img.loading='eager';});
        this.preloadNext();
        this.schedule();
      }
      updateRail(list) {
        const controls=list.closest('.gf-care__products');
        controls.querySelector('[data-care-products="-1"]').disabled=list.scrollLeft<2;
        controls.querySelector('[data-care-products="1"]').disabled=list.scrollLeft+list.clientWidth>=list.scrollWidth-3;
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
